module.exports = __webpack_public_path__ + "static/media/IconTemplates_-08.139ed2c4.svg";